import React, { useMemo } from "react";
import { Icon } from "@alm/flow-ds/components";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import CustomError from "lib/api/CustomError";

type Props = {
	error: CustomError;
};

const ActivityInstancesError = ({ error }: Props) => {
	const { t } = useTranslation();

	const text = useMemo(() => {
		if (error?.message) return error.message;
		switch (error?.httpCode) {
			case 404:
				return t("alerts.instanceMissingError");
			default:
				return t("alerts.unexpectedInstanceError");
		}
	}, [error, t]);

	return (
		<div className="mt-5 text-muted" style={{ textAlign: "center" }}>
			<Icon type="file-excel" weight="d" className="fa-4x mb-3" />
			{error?.httpCode && <h3>{error.httpCode}</h3>}
			<p className="lead">{text}</p>
			<Link to="/activity-instances">
				{t("main.activityInstances.text.backToActivityInstances")}
			</Link>
		</div>
	);
};

export default React.memo(ActivityInstancesError);
